import React from "react";
import InstrumentChoice from "./InstrumentChoice";
import { instrumentWith } from "../models";
import {searchForStockUsingServer} from "../actions/searchForInstrumentsUsingServer";

const EquitiesInstrument = (props) => (
    <InstrumentChoice value={ props.value }
                      onChange={ chosenSearchResult => props.onChange(toInstrumentAttributes(chosenSearchResult))}
                      className={props.className}
                      searchForInstrument={ searchForStockUsingServer } />
);
EquitiesInstrument.propTypes = {
    className: React.PropTypes.string,
    onChange: React.PropTypes.func,
    value: React.PropTypes.shape({
        symbol: React.PropTypes.string,
        name: React.PropTypes.string
    })
};
EquitiesInstrument.defaultProps = {
    value: {
        symbol: null,
        name: null
    }
};

function toInstrumentAttributes(chosenSearchResult) {
    return instrumentWith({
        name: chosenSearchResult.name,
        symbol: chosenSearchResult.bloomberg,
        instrumentId: chosenSearchResult.quoteId,
        recommendableType: chosenSearchResult.recommendableType,
        indicativePrice: chosenSearchResult.indicativePrice,
        recommendable: chosenSearchResult
    });
}

export default EquitiesInstrument;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/EquitiesInstrument.js
 **/